import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from 'react-redux'


const PrivateRoute = ({ component: RouteComponent, ...rest }) => {
  const {syncs} =  useSelector((state)=>{ return state });
  const { vendedor } = syncs && syncs.vendedor? syncs: false;
  return (
    <Route
      {...rest}
      render={routeProps =>
        vendedor ? (
          <RouteComponent {...routeProps} />
        ) : (
          <Redirect to={"/login"} />
        )
      }
    />
  );
};


export default PrivateRoute